import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-391e6b1e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "manage-page"
};
const _hoisted_2 = {
  class: "content mb"
};
const _hoisted_3 = {
  class: "cell mr"
};
const _hoisted_4 = {
  alt: ""
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "智能化驱动生成", -1));
const _hoisted_6 = {
  class: "cell mr"
};
const _hoisted_7 = {
  alt: ""
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "智能化用例评估", -1));
const _hoisted_9 = {
  class: "cell"
};
const _hoisted_10 = {
  alt: ""
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "智能化优先级评定", -1));
const _hoisted_12 = {
  class: "content"
};
const _hoisted_13 = {
  class: "cell mr"
};
const _hoisted_14 = {
  alt: ""
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "提供修复建议", -1));
const _hoisted_16 = {
  class: "cell"
};
const _hoisted_17 = {
  alt: ""
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "自动生成修复代码", -1));
export function render(_ctx, _cache) {
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [[_directive_lazy, require('@/assets/img/index/reportExport.png')]]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [[_directive_lazy, require('@/assets/img/index/loopPoc.png')]]), _hoisted_8]), _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [[_directive_lazy, require('@/assets/img/agent/intelligentPriorityRating.png')]]), _hoisted_11])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [[_directive_lazy, require('@/assets/img/index/defectCodeSuggets.png')]]), _hoisted_15]), _createElementVNode("div", _hoisted_16, [_withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [[_directive_lazy, require('@/assets/img/agent/automaticallyRepairCode.png')]]), _hoisted_18])])]);
}